import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { DadosProvider } from '../dados/dados';
import { SemovelProvider } from '../semovel/semovel';


@Injectable()
export class CarrinhoProvider {

  private itens: Array<any>;

  total = 0;

  private erros: Array<string>;

  voucher;

  desconto;
  
  private valorEntrega;


  constructor(public eve:Events, private dados:DadosProvider, private server:SemovelProvider) {
    this.inicializar();
  }

  salvarItens(){
    this.dados.set("itens", this.itens);
  }

  dispararEventoTotal(){
    this.eve.publish("carrinho:atualizar_total", this.total);
  }

  dispararEventoQuantidade(){
    this.eve.publish("carrinho:atualizar_quantidade", this.itens.length);
  }

  dispararEventoItens(){
    this.eve.publish("carrinho:atualizar_itens", this.itens);
  }

  public  getItens():Array<any>{
    return this.itens;
  }
  public inicializar(){
    this.itens = [];
    this.total = 0;

    this.dados.get("itens").subscribe(
      (itensSalvos) => {
        if(itensSalvos){
          this.itens = itensSalvos;

          this.calcularTotal();
        }
      }
    );
  }

  public atualizarPrecos(){

    if(!this.itens && !this.itens.length){
      return;
    }

    this.server.postData({method:"verificar_precos"},{itens:this.itens}, false).subscribe(
      (itensServer) =>{
        if(itensServer){
          for (let i = 0; i < itensServer.length; i++) {
            let itemServer = itensServer[i];
            
            for (let j = 0; j < this.itens.length; j++) {
              let item = this.itens[j];
              if(item.produto_id == itemServer.produto_id && item.unidade_id == itemServer.unidade_id){
               
                item.valor_unitario = itemServer.valor_unitario;
                item.valor_total = item.quantidade * item.valor_unitario;

              }
            }

            this.calcularTotal();
          }
        }
      }
    );
  }

  public adicionar(produto, unidade){
    let item:any;

    for(let i in this.itens) {       
      const itemCarrinho = this.itens[i];
      if(itemCarrinho.produto.id == produto.id){
        itemCarrinho.quantidade = itemCarrinho.quantidade + 1;
        itemCarrinho.valorTotal = itemCarrinho.quantidade * itemCarrinho.valorUnitario;
        item = itemCarrinho;
      }
    }
    
    if(!item){
      this.itens.push({
        produto,
        nomeProduto:produto.nome,
        unidade:produto.unidade ? produto.unidade.sigla:'',
        imagem:produto.imagem,
        valorUnitario: Number.parseFloat(produto.precoVenda),
        quantidade: 1,
        valorTotal: Number.parseFloat(produto.precoVenda),
      });
    }
    this.salvarItens();
    this.calcularTotal();
    this.dispararEventoTotal();
    this.dispararEventoQuantidade();
  }

  public remover(item){

  }

  public atualizar(){

  }

  public aplicarDesconto(valorDesconto){
    
  }
  
  public aplicarTaxaDesconto(taxaDesconto){

  }

  public aplicarTaxaEntrega(taxaEntrega){

  }
  
  private mudarQuantidade(item, quantidade){
    item.quantidade = item.quantidade + quantidade;
    item.valorTotal = item.quantidade * item.valorUnitario;
    
    this.salvarItens();
    this.calcularTotal();
  } 

  public aumentarItem(item){
    this.mudarQuantidade(item, 1);
  }
  
  public diminuirItem(item){
    if(item.quantidade > 1) this.mudarQuantidade(item, -1);
  }
  
  public calcularTotal(){
    this.total = 0;
    this.desconto = 0.0;
    
    this.itens.forEach(element => {
      this.total += element.valorTotal;
    });
    
    //Sem voucher por enquanto.
    // if(this.voucher && (!this.voucher.valorminimo ||  this.voucher.valorminimo <= this.total) ){
    //   if(this.voucher.desconto){
    //     this.desconto = (this.total * this.voucher.desconto / 100.00);
    //   }else if( this.voucher.valor ){
    //     this.desconto = this.voucher.valor;
    //   }
    // }else{
    //   this.desconto = 0.0;
    // }

    this.dispararEventoTotal();
  }
  
  public removerItem(item, index){
    this.itens.splice(index, 1);

    this.salvarItens();
    this.dispararEventoItens();
    this.calcularTotal();
  }

  validar_pedido(){
    this.erros = [];

    if(!this.itens.length){
      this.erros.push("Nenhum item foi informado.");
    }

    return this.erros.length == 0;
  }

  visualizar_erros(){
    let erro = "";
    
    for(var i in this.erros) {             
      erro += this.erros[i]+"<br>";    
    }
    
    return erro;
  }

  carregar_pedido():any{
    let pedido:any;

    pedido = {};

    //Temporario até o login estar funcionando
    pedido.itens = this.itens;
    
    if(this.voucher){
      pedido.voucher = this.voucher;
    }
    
    return pedido;
  }


  limpar_pedido(){
    this.itens = [];
    this.total = 0.0;
    this.dispararEventoItens();
    this.dispararEventoQuantidade();
    this.dispararEventoTotal();
    this.desconto = 0.0;
    this.voucher = null;

    this.salvarItens();
  }

  isEntregaGratis(){
    if(this.total >= this.dados.getValorMinimoPedidoEntrega()){
      return true;
    }
    return false;
  }

  aplicarVoucher(voucher:any){
    this.voucher = voucher;

    this.calcularTotal();
  }

  totalCalculado(){
    let totalCalculado = this.total;

    if(this.desconto) totalCalculado -= this.desconto;

    if(this.valorEntrega) totalCalculado += this.valorEntrega;

    return totalCalculado;
  }

  setValorEntrega(valorEntrega){
    this.valorEntrega = valorEntrega;
  }
}



// WEBPACK FOOTER //
// ./src/providers/carrinho/carrinho.ts